import React, { forwardRef } from 'react';
import { MenuItem as MuiMenuItem } from '@mui/material';

export interface MenuItemProps {
  className?: string;
  selected?: boolean;
  component?: React.ElementType | undefined;
  onClick?: React.MouseEventHandler<HTMLLIElement>;
  disabled?: boolean;
  children?: React.ReactNode;
  value?: string | number | readonly string[] | undefined;
  style?: React.CSSProperties;
  // Anchor props for when component="a"
  href?: string;
  target?: string;
  rel?: string;
}

/**
 * This Component is a wrapper on MUI component.
 * This component should be imported and not MUI directly!
 *
 * `forwardRef` so a caller can reach the rendered `<li>`. Two callers need it and neither can be
 * served another way: MUI's own `Menu` measures its children to position and keyboard-navigate the
 * list, and `SuggestionMenuItem` scrolls the selected row into view after the groups above it
 * expand. Without it React drops the ref with a warning and the ref stays null, which reads as
 * "the scroll silently did nothing" rather than as an error.
 */
const MenuItem = forwardRef<HTMLLIElement, MenuItemProps>(({ children, ...menuItemProps }, ref) => {
  return (
    <MuiMenuItem ref={ref} {...menuItemProps}>
      {children}
    </MuiMenuItem>
  );
});

MenuItem.displayName = 'MenuItem';

export default MenuItem;
